export const runTasksInChunks = async <T = void>(tasks: Promise<T>[], chunkSize = 6): Promise<T[]> => {
    const results: T[] = [];
    for (let i = 0; i < tasks.length; i += chunkSize) {
        const chunk = tasks.slice(i, i + chunkSize);
        const chunkResults = await Promise.all(chunk);
        results.push(...chunkResults);
    }
    return results;
};

export const pollUntilComplete = (
    getProgress: () => Promise<number | null | undefined>,
    intervalMs = 500
): Promise<void> => {
    return new Promise((resolve, reject) => {
        const poll = async () => {
            try {
                const progress = await getProgress();
                if (progress != null && progress >= 100) {
                    resolve();
                    return;
                }
                setTimeout(poll, intervalMs);
            } catch (err) {
                reject(err);
            }
        };
        poll();
    });
};

export const getReasonErrorMessage = (reason: any) => {
    if (reason instanceof Error) return reason.message;
    if (typeof reason === 'string') return reason;

    try {
        return JSON.stringify(reason);
    } catch {
        return String(reason);
    }
};
